import {
  ChangeDetectorRef,
  ElementRef,
  Injectable,
  NgZone,
  Renderer2
} from '@angular/core';
import {
  LMBusyIndicatorService,
  LMCompoundFieldService,
  LMComponentInfoService,
  LMContextService,
  LMFieldUtilService,
  LMLoggerService,
  LMUrlInfoBuilderService,
  LMUrlUtilService,
  LMModalOpenService,
  LMModalWrapperService
} from '@services/index';
import {
  LMBrowserUtilService,
  LMCommonUtilService,
  LMConditionUtilService,
  LMGlobalUtilService,
  LMUniqueIdService
} from '@utils/index';
import { LMFormatUtilService } from '@services/utils';
import { LMFormService, LMFormSpecUtilService } from '@form/services/index';
import { LMFieldSubscriptionService } from './lm-field-subscription.service';
import {
  LMFieldLayoutService,
  LMFieldOptionsService,
  LMFieldOptionsToolbarService
} from './services';
import { LMThemeService } from '@banner/lm-theme.service';
import { LMGlobalPersonalizationService } from '@states/services';
import { LMKeyboardShortcutService } from '@services/lm-keyboard-shortcut.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LMAppComponentService } from '@utils/lm-app-component.service';

@Injectable()
export class LMFieldServiceAdapter {

  // this class is used to provide services with a single Dependency Injection to
  // a field component and the field base component

  constructor(
    public lmBrowserUtilService: LMBrowserUtilService,
    public lmBusyIndicatorService: LMBusyIndicatorService,
    public lmConditionUtilService: LMConditionUtilService,
    public lmContextService: LMContextService,
    public lmFormatUtilService: LMFormatUtilService,
    public lmFormService: LMFormService,
    public lmFormSpecUtilService: LMFormSpecUtilService,
    public lmGlobalUtilService: LMGlobalUtilService,
    public lmLoggerService: LMLoggerService,
    public lmFieldSubscriptionService: LMFieldSubscriptionService,
    public lmFieldLayoutService: LMFieldLayoutService,
    public lmCompoundFieldService: LMCompoundFieldService,
    public lmCommonUtilService: LMCommonUtilService,
    public lmFieldOptionsToolbarService: LMFieldOptionsToolbarService,
    public lmFieldOptionsService: LMFieldOptionsService,
    public changeDetectorRef: ChangeDetectorRef,
    public lmComponentInfoService: LMComponentInfoService,
    public lmThemeService: LMThemeService,
    public ngZone: NgZone,
    public lmUniqueIdService: LMUniqueIdService,
    public elementRef: ElementRef,
    public lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    public lmUrlUtilService: LMUrlUtilService,
    public lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    public renderer2: Renderer2,
    public lmFieldUtilService: LMFieldUtilService,
    public lmKeyBoardShortcutService: LMKeyboardShortcutService,
    public domSanitizer: DomSanitizer,
    public lmAppComponentService: LMAppComponentService,
    public lmModalWrapperService: LMModalWrapperService,
    public lmModalOpenService: LMModalOpenService
  ) {}

}
